module.exports = [{
      plugin: require('../../node_modules/.pnpm/gatsby-plugin-catch-links@5.16.0_gatsby@5.16.1_babel-eslint@10.1.0_eslint@8.57.1__react_f16fd0c7a2764a453d49ca361a84c02a/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../node_modules/.pnpm/gatsby-plugin-styled-components@6.16.0_babel-plugin-styled-components@1.13.3_styled-com_639684467b2fb239af22c7ccdf4e8019/node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_eslint@8.57.1__react-dom@18.0.0_react@18.0.0__react@1_8cce563fcdcf5a8b4320a0774516e977/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
